import { MultiSelect } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import { useFiltro } from '../../../../../../../../contexts/FilaEmbarque/Filtro/hooks/useFiltro';
import StatusMotoristaEnum from '../../../../../../Enum/StatusMotoristaEnum';

export default function StatusSelect({ dispatchField }) {
  const [statusOptions, setStatusOptions] = useState([]);
  const { filtro } = useFiltro();
  const { status: statusDoContext } = filtro.filtrosDrawer;
  const statusSelecionados = useMemo(
    () => statusOptions.filter(option => option.checked),
    [statusOptions]
  );

  const getLabel = () =>
    statusSelecionados.length > 0
      ? `${statusSelecionados.length} ${
          statusSelecionados.length === 1 ? 'Selecionado' : 'Selecionados'
        }`
      : 'Todos';

  const handleSelectStatus = async options => {
    setStatusOptions(options);
    const status = options.map(option => option.id);
    dispatchField({ status });
  };

  useEffect(() => {
    if (statusDoContext.length === 0) {
      setStatusOptions(prevState =>
        prevState.map(option => ({ ...option, checked: false }))
      );
    }
  }, [statusDoContext]);

  useEffect(() => {
    (() => {
      const motoristaStatusOptions = StatusMotoristaEnum.getTiposLabel()
        .filter(
          item =>
            item.label !== 'Desistiu' && item.label !== 'Aguardando aprovação'
        )
        .map(item => ({
          id: item.value,
          label: item.label,
          checked: false,
        }));
      setStatusOptions(motoristaStatusOptions);
    })();
  }, []);

  return (
    <MultiSelect
      data-testid="multiselect-status"
      dropdownInputStyle={{
        height: '48px',
        borderRadius: '4px',
      }}
      options={statusOptions}
      label={getLabel()}
      onChange={handleSelectStatus}
    />
  );
}
StatusSelect.propTypes = {
  dispatchField: PropTypes.func.isRequired,
};
